const upperCaseLetterRegex = /[A-Z]/;
const lowerCaseLetterRegex = /[a-z]/;
const numericCharacterRegex = /\d/;
const specialCharacterRegex = /[!@#$%^&*(),.?":{}|<>]/;
export {
  upperCaseLetterRegex,
  lowerCaseLetterRegex,
  numericCharacterRegex,
  specialCharacterRegex,
};